import { AxiosResponse } from 'axios';
import { CallHistoryMethodAction, goBack } from 'connected-react-router';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import { onGetDmsListSuccess, onGetFullDmsListSuccess } from '../actions';

// dmsList
const getDmsApi = async (
  pageSize: number,
  folder: string,
  pageNumber: number,
  search: string,
  isDelete: boolean,
  isExpire: boolean | null,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`DmsArchive/DocumentList`, {
    params: {
      folder: folder,
      search: search,
      isDelete: isDelete,
      isExpire: isExpire,
      pageSize: pageSize,
      pageNumber: pageNumber,
    },
  });
};

function* dmsListRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  CallHistoryMethodAction<[]> | void,
  AxiosResponse<any>
> {
  try {
    const response = yield call(
      getDmsApi,
      action.payload.pageSize,
      action.payload.folder,
      action.payload.pageNumber,
      action.payload.search,
      action.payload.isDelete,
      action.payload.isExpire,
    );
    yield put(onGetDmsListSuccess(response.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* dmsList() {
  yield takeEvery(ActionTypes.GET_DMS_LIST, dmsListRequest);
}

const getFullDmsApi = async (
  pageNumber: number,
  search?: string,
  code?: string,
  id?: number,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`DmsArchive/ArchiveFolderRead`, {
    params: {
      pageNumber: pageNumber,
      q: search,
      code: code,
      id: id,
    },
  });
};
function* dmsFullListRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  CallHistoryMethodAction<[]> | void,
  AxiosResponse<any>
> {
  try {
    const response = yield call(
      getFullDmsApi,
      action.payload.pageNumber,
      action.payload.search,
      action.payload.code,
      action.payload.id,
    );
    yield put(onGetFullDmsListSuccess(response.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* dmsFullList() {
  yield takeEvery(ActionTypes.GET_DMS_FULL_LIST, dmsFullListRequest);
}
export default function* rootSaga() {
  yield all([fork(dmsList), fork(dmsFullList)]);
}
